<script lang="ts">
  import AmaReportPathType from './AmaReportPathType.svelte';

  interface Props {
    path?: string;
    name?: string;
    onevent?: (payload: any) => void;
  }

  let { path = '', name = '', onevent }: Props = $props();
</script>

<div class="ama-attachment-type">
  <div data-cy={`header`} class="header">
    <div class="title">Attachments</div>
  </div>
  <div data-cy={`attachment-contents`} class="contents">
    <div class="key">AMA Profile</div>
    <div class="value">
      <AmaReportPathType fileName={name} filePath={path} {onevent} />
    </div>
  </div>
</div>

<style>
  .ama-attachment-type {
    width: 100%;
    background-color: #fff;
    padding-bottom: 15px;
    margin-top: 20px;
  }
  .header {
    display: flex;
  }
  .header .title {
    font-weight: 700;
    font-size: 20px;
    line-height: 26px;
    color: var(--black);
    margin-bottom: 24px;
  }
  .contents {
    display: flex;
    align-items: flex-start;
    padding: 12px 16px;
    line-height: 20px;
    color: var(--grey-dark);
    background-color: var(--grey-bg) !important;
  }
  .key {
    width: 150px;
    flex-shrink: 0;
    margin-right: 16px;
    overflow: hidden;
    color: var(--black);
    font-weight: 500;
  }
  .value {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>
